<div class="mon-dialog-header">
    <page-header header="{{'Setup your domain' | translate }}"
                 panelLeftClass="col-48 mt-2" >
    </page-header>
</div>
<div class="mon-dialog-body bg-body pt-3">
    <div class="card panel-monsido-card mx-4">
        <div class="card-body">
            <p translate>
                You have now created your domain - the last step is to add the Acquia Web Governance tracking code to your website. <br>
                The tracking code enables the show on page function and makes it possible for Acquia Web Governance to keep track of which pages on your domain are the most important.
            </p>

            <p class="mb-5 text-bold" translate>
                All you have to do is insert the script below in your website's BODY-tag. Just copy and paste it as it is.
            </p>
            <div class="px-3">
                <form-domain-script-guide-legacy-statistics>
                </form-domain-script-guide-legacy-statistics>
                <form-domain-script-guide-legacy-page-assist prefixName="page_assist_legacy"
                                                             [pageAssistModel]="pageAssistModel"
                                                             [domain]="domain">
                </form-domain-script-guide-legacy-page-assist>
                <form-domain-script-guide-features-heatmaps prefixName="legacy">
                </form-domain-script-guide-features-heatmaps>
            </div>

            <div class="mon-script-wrapper">
                <mon-copy target="{{ id }}"></mon-copy>
<pre class="yellow" id="{{ id }}">&lt;script type="text/javascript"&gt;
    window._monsido = _monsido || [];
    <span [innerHTML]="getVariables()"></span>
&lt;/script&gt;
&lt;script async src="//cdn.monsido.com/tool/javascripts/monsido.js"&gt;&lt;/script&gt;
<span [innerHTML]="getExternalScripts()"></span></pre>
            </div>
        </div>
    </div>
</div>
